




// import React, { Component } from "react";
// import ReactDOM from "react-dom";
// import ColorPicker from "react-color-picker-text";
// // import "./styles.css";

// import '../App.css'

// export default class AssetsNavigator extends Component {

//   onColorPickerInfoChange = color => {
//     console.log("Main Color Change", color);
//   };

//   render() {
//     // change the default design of the color picker
//     const styles = {
//       title: "Color Picker",
//       labelStyle: {
//         paddingBottom: "7px",
//         fontSize: "11px"
//       },
//       colorTextBoxStyle: {
//         height: "35px",
//         border: "none",
//         borderBottom: "1px solid lightgray",
//         paddingLeft: "35px"
//       }
//     };
//     return (
//       <ColorPicker
//         onColorChange={this.onColorPickerInfoChange}
//         title={styles.title}
//         labelStyle={styles.labelStyle}
//         colorTextBoxStyle={styles.colorTextBoxStyle}
//         pickerType={"Chrome"}
//       />
//     );
//   }
// }




import React, { Component } from 'react';
// import { render } from 'react-dom';
// import Hello from './Hello';
// import './style.css';

import '../../App.css'
import TeamInfo from '../TeamInfo';
export default class Assets extends Component {
    constructor() {
        super();
        this.state = {
            color: [],
            data:{}
        };
    }

    ItemChecked(e) {
        var tValue = e.target.value;
        this.setState({ color: tValue });
    }

    render() {
        return (
            <div>
                {/* <label>
                    <div class="result" style={{ backgroundColor: this.state.color }}></div>
                    <input type="color" id="color-picker" ref="color-value" onChange={this.ItemChecked.bind(this)} />
                    <span class="select"></span>
                </label> */}
                <TeamInfo data={this.state.data}/>
            </div>
        );
    }
}











